import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { PROFILE_ID } from '../../components/profiles-grid/profiles-grid.component';

export const RulesAssociationSingularProfileResolver: ResolveFn<boolean> =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
    return route.params.profileId === PROFILE_ID.RULE_ASSOCIATION && route.queryParams['mode'];
  };
